'use client';

import { useDebouncedEffect } from '@react-hookz/web';
import { useCallback, useState } from 'react';

const getDelay = (
  latency: number | undefined,
  fullLength: number,
  currentLength: number,
  minDelay: number,
  maxDelay: number,
) => {
  const delay = (latency || 0) / (fullLength - currentLength || 1);
  return Math.min(Math.max(delay, minDelay), maxDelay);
};

const useTypewriter = (
  text: string,
  latency: number | undefined,
  onFinish?: () => void,
) => {
  const [streamedText, setStreamedText] = useState<string>(text[0] || '');

  const reset = useCallback(() => {
    setStreamedText('');
  }, []);

  useDebouncedEffect(
    () => {
      if (latency === undefined) return;

      if (streamedText.length + 1 >= text.length && text.length > 0) {
        onFinish?.();
      }

      setStreamedText((curr) => text.slice(0, curr.length + 1));
    },
    [text, streamedText, latency, onFinish],
    getDelay(latency, text.length, streamedText.length, 20, 80),
  );

  return { streamedText, reset };
};

export default useTypewriter;
